import type { TSafeAreaInsetValues } from './types'

export const areSafeAreaInsetsEqual = (a: TSafeAreaInsetValues, b: TSafeAreaInsetValues) =>
  a.top === b.top && a.right === b.right && a.bottom === b.bottom && a.left === b.left
